if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartMain = document.querySelector('[data-cart-wrapper]');
      this.productServices = document.querySelectorAll('[data-product-service]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      const mainCartSections = [
        {
          id: 'main-cart',
          selector: '[data-cart-wrapper]',
        },
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];

      const sectionsToFetch = [
        ...(this.cartDrawer ? this.cartDrawer.getSectionsToRender().map((section) => section.id) : []),
        ...(this.cartMain ? mainCartSections.map(section => section.id) : []),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id)
      ];

      const formData = new FormData(this.form);

      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);

      config.body = {
        sections: sectionsToFetch.join(','),
        sections_url: window.location.pathname
      }

      formData.forEach((value, key) => {
        if (key == 'items') {
          config.body[key] = JSON.parse(value);
        }
      });

      this.productServices.forEach((productService) => {
        const productServiceEl = productService.querySelector('input');
        if (productServiceEl.checked) {
          const productService = {
            id: parseInt(productServiceEl.value),
            quantity: 1
          }
          config.body.items.push(productService);
        }
      });

      config.body = JSON.stringify(config.body);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            const productName = parsedState.description.split("'")[1].split("'")[0];
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(productName);
            return;
          }

          this.cartDrawer?.renderContents(parsedState);

          if (this.cartMain) {
            mainCartSections.forEach((section) => {
              document.querySelector(section.selector).innerHTML =

                new DOMParser()
                  .parseFromString(parsedState.sections[section.id], 'text/html')
                  .querySelector(section.selector).innerHTML;
            });
          }

          switch (submitButton.dataset.addToCartBehavior) {
            case ('open_cart_drawer'):
              this.cartDrawer?.open();
              break;
            case ('show_cart_notification'):
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


